import FormValidator from 'utils/form-validator';

export default class ResetPassword {
  constructor() {
    const form = document.querySelector('main form');
    if (typeof form !== 'undefined') {
      new FormValidator(form, () => {
      });
    }
  }
}
